angular.module('CarsSaraBo').controller('ModerateController', ['$scope','SessionService', 'SpecialOfferService','$window','SpecialOfferGAConfig', 'GeoService', '$http', 'NotificationService', '$location',
	function ($scope, sessionService, specialOfferService, $window, analyticsConfig, geoService, $http, notificationService, $location) {

		$scope.initialize = function () {
			$scope.pagination = {
				itemsPerPage: 20,
				currentPage: 1,
				numPages: 0,
				totalItems: 0
			};

			$scope.sendTrackingEmailNotificacion();
			$scope.filters = {approvalStatus: "PENDING", orderType: "asc"}; // en este listado sólo se muestran las pendientes
            $scope.isEmptyState = false;
            $scope.isNoMatchedOffers = false;
			$scope.pendingSpecialOffersList = [];
			$scope.moderableSpecialOffer = $scope.loggedUserAllowed('PERM_SPECIAL_OFFER_MODERATE');
            $scope.getPendingSpecialOffers();
			getCountries();
		};

		$scope.sendTrackingEmailNotificacion = function() {
			var decodedURI = decodeURIComponent($location.url());//decoding URL
			$location.url(decodedURI);//setting to angular, the URL decoded
			var searchObject = $location.search();//getting the object query params
			var paramSpecialOfferOid = searchObject.specialOfferOid;//getting query param


			if(paramSpecialOfferOid){
				specialOfferService.clickMailButton(paramSpecialOfferOid);//calling to the service that storage click event
				$location.url($location.path());//setting to angular, the URL without query params
			}
		};

		function getCountries(){
			geoService.getCountries().then(function(response) {
				$scope.countries = response.data;
			});
		}

		var gaModerate = analyticsConfig.moderateGa();

        $scope.getPendingSpecialOffers = function() {
            $scope.showProgressBar();
            if ($scope.filters.countryOid) {
                specialOfferService.fetchByFilter($scope.filters, $scope.pagination.currentPage, 20).then(function(response) {
                    $scope.pagination = {
                        itemsPerPage: response.itemsPerPage,
                        currentPage: response.currentPage,
                        numPages: Math.floor(response.totalItems/response.itemsPerPage) +
                        (response.totalItems/response.itemsPerPage>0?1:0),
                        totalItems:response.totalItems
                    };
                    $scope.pendingSpecialOffersList = response.items;
                    if (_.isEmpty($scope.pendingSpecialOffersList)) {
                        specialOfferService.fetchByFilter({approvalStatus: "PENDING"}, $scope.pagination.currentPage, 20).then(function(notFilteredResponse) {
                            $scope.isEmptyState = _.isEmpty(notFilteredResponse);
                            $scope.isNoMatchedOffers = !$scope.isEmptyState;
                            $scope.hideProgressBar();
						});
                    } else {
                        $scope.isNoMatchedOffers = false;
						$scope.hideProgressBar();
					}
                });
			} else {
                specialOfferService.fetchByFilter($scope.filters, $scope.pagination.currentPage, 20).then(function(response) {
                    $scope.pagination = {
                        itemsPerPage: response.itemsPerPage,
                        currentPage: response.currentPage,
                        numPages: Math.floor(response.totalItems/response.itemsPerPage) +
                        (response.totalItems/response.itemsPerPage>0?1:0),
                        totalItems:response.totalItems
                    };
                    $scope.pendingSpecialOffersList = response.items;
					$scope.isEmptyState = _.isEmpty($scope.pendingSpecialOffersList);
					$scope.isNoMatchedOffers = false;
                    $scope.hideProgressBar();
				});
			}

        };

		$scope.moderate = function (specialOffer, status) {
			if (status === 'REJECTED') {
				gaModerate.send("Intencion_rechazar_promocion", specialOffer, "Pantalla_moderacion")
				$scope.showModal('REJECT_SPECIAL_OFFER_TITLE', 'REJECT_SPECIAL_OFFER_MESSAGE', function () {
					specialOfferService.moderate(specialOffer.companyOid, specialOffer.oid, status)
						.then(function (response) {
							gaModerate.send("Rechazar_promocion", specialOffer, "Pantalla_moderacion")
							notificationService.displayToast('specialOffers.toast.REJECTED_SPECIAL_OFFER_TITLE', 'specialOffers.toast.REJECTED_SPECIAL_OFFER_MESSAGE',
								{"name": specialOffer.name});
							$scope.initialize();
						}, function (error) {
							console.log(error);
						});
				});
			}

			if (status === 'APPROVED') {
				specialOfferService.moderate(specialOffer.companyOid, specialOffer.oid, status)
					.then(function () {
						gaModerate.send("Aprobar_promocion", specialOffer, "Pantalla_moderacion")
						notificationService.displayToast('specialOffers.toast.APPROVED_SPECIAL_OFFER_TITLE', 'specialOffers.toast.APPROVED_SPECIAL_OFFER_MESSAGE',
							{"name": specialOffer.name});
						$scope.initialize();
					}, function (error) {
						console.log(error);
					});
			}
		};

		$scope.changePage = function(){
			$scope.getPendingSpecialOffers();
			$window.scrollTo(0, 0);
		};

		$scope.paginationFromNumber = function () {
			return 1 + (($scope.pagination.currentPage - 1) * $scope.pagination.itemsPerPage);
		};

		$scope.paginationToNumber = function () {
			return $scope.paginationFromNumber() + $scope.pendingSpecialOffersList.length -1;
		};


		$scope.notifyGA = function (eventName, param) {
			gaModerate.send(eventName, param);
		};

        $scope.companyNameLike = function(nameLike) {
        	var config = {
        		params: {
                    nameLike: nameLike
				}
			};
            return $http.get("../rest/company/search", config).then(function(response) {
                return response.data
            });
        };

        $scope.onCompanySelect = function ($item) {
            $scope.filters.companyOid = $item.oid;
            $scope.getPendingSpecialOffers();
        };

        $scope.onCompanyChange = function() {
            if ($scope.company == '' || $scope.company == undefined) {
                delete $scope.filters.companyOid;
                $scope.getPendingSpecialOffers();
            }
        };

		$scope.initialize();

	}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/moderate_controller.js
// module id = 903
// module chunks = 3